var render = function render(){var _vm=this,_c=_vm._self._c;return _c('observer-component',{attrs:{"refId":'btoMyBetsLoadMore'}},[_c('my-bets-inline')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }